import React from 'react';

import { isOverseas } from '@whelk/const/src/env';

import OverseasLoginModal from './components/OverseasLoginModal';
import PhoneLoginModal from './components/PhoneLoginModal';

import './style.scss';
const LoginModal = () => {
  return <>{isOverseas ? <OverseasLoginModal /> : <PhoneLoginModal />}</>;
};

export { LoginModal };
